import { render, staticRenderFns } from "./ContentMain.vue?vue&type=template&id=76896181&"
import script from "./ContentMain.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContentMain.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports